import React from 'react';
import { Card } from './ui/Card';
import { Wrench, Zap, Gauge, GraduationCap } from 'lucide-react';
const LEARNING_ITEMS = [{
  icon: <Wrench className="w-8 h-8 text-cyan-400" data-id="element-33" />,
  title: 'MOTORES Y TRANSMISIÓN',
  points: ['Motores 2T y 4T (Desarme y armado completo).', 'Cilindradas desde 110cc hasta 250cc+.', 'Embrague profesional y sistema de transmisión.']
}, {
  icon: <Gauge className="w-8 h-8 text-cyan-400" data-id="element-34" />,
  title: 'ALIMENTACIÓN Y DIAGNÓSTICO',
  points: ['Carburador e Inyección (Sistemas clásicos y modernos).', 'Sistema de frenos integral (Disco, tambor y líquidos).', 'Método exacto para diagnóstico de fallas reales.']
}, {
  icon: <Zap className="w-8 h-8 text-cyan-400" data-id="element-35" />,
  title: 'ELECTRICIDAD Y MANTENIMIENTO',
  points: ['Electricidad completa (CDI, bobinas, sensores, arranque).', 'Suspensión (Horquillas y amortiguadores).', 'Puesta a punto y Service (5K, 10K y 20K kilómetros).']
}, {
  icon: <GraduationCap className="w-8 h-8 text-cyan-400" data-id="element-36" />,
  title: 'TU CAJA DE HERRAMIENTAS DIGITAL',
  points: ['Guías en video de alta precisión para diagnóstico y reparación inmediata.', 'Diagramas eléctricos y manuales técnicos listos para descargar.', 'Acceso instantáneo desde tu celular, directamente en el taller.']
}];
export function LearningCarousel() {
  return <div className="w-full py-8" data-id="element-37">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 px-4 md:px-0" data-id="element-38">
        {LEARNING_ITEMS.map((item, idx) => <Card key={idx} className="h-full bg-slate-950 border border-cyan-500/30 shadow-[0_0_15px_rgba(6,182,212,0.1)] p-6 flex flex-col items-center text-center" data-id="element-39">
            <div className="bg-slate-900 p-4 rounded-full mb-4 border border-slate-800" data-id="element-40">
              {item.icon}
            </div>
            <h3 className="text-xl font-bold text-white mb-4 uppercase tracking-wide" data-id="element-41">
              {item.title}
            </h3>
            <ul className="space-y-3 text-left w-full" data-id="element-42">
              {item.points.map((point, pIdx) => <li key={pIdx} className="text-slate-400 text-sm flex gap-2 items-start" data-id="element-43">
                  <span className="text-cyan-500 mt-1" data-id="element-44">•</span>
                  {point}
                </li>)}
            </ul>
          </Card>)}
      </div>
    </div>;
}